import React from 'react';
import ContainerShape from "./ContainerShape";
import RaiseTheGarden from "./RaiseTheGarden";
import style from "./PotgrondCalculator.css";

let classNames = require("classnames");

class PotgrondCalculator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null
        };

        this.handleActionChange = this.handleActionChange.bind(this);
    }

    handleActionChange(changeEvent) {
        this.setState({
            selectedOption: changeEvent.target.value
        });
    }

    render() {
        let calculatorForm = '';
        let selectedOption = this.state.selectedOption;
        if (selectedOption === 'In een pot zetten') {
            calculatorForm = <ContainerShape />
        } else if(selectedOption === 'Tuin ophogen'){
            calculatorForm = <RaiseTheGarden />
        }

        return <div>
            <div className="radio-buttons">
                <p>Wilt u een plant in een pot zetten, of (een deel van) uw tuin ophogen?</p>

                {["In een pot zetten", "Tuin ophogen"].map((name) => {
                    let className = name.replace(' ', '-').toLowerCase();
                    return <label htmlFor={name} key={name} className={classNames({
                        className : true,
                        "active": this.state.selectedOption === name
                    })}>
                        <span>{name}</span>
                        <input
                            type="radio"
                            name="action"
                            id={name}
                            value={name}
                            checked={this.state.selectedOption === name}
                            onChange={this.handleActionChange} />
                    </label>
                })}
            </div>
            { calculatorForm }
        </div>
    }
}

export default PotgrondCalculator;